// src/socketClient.js
import { io } from "socket.io-client";
import { REACT_APP_API_URL } from "./config";

let socket = null;
let hasInitListeners = false;
let lastToken = null;
let disabledUntilReset = false;

const MAX_RECONNECT_ATTEMPTS = 3;

export function getSocket() {
  if (disabledUntilReset) {
    console.log("[socket] disabledUntilReset=true -> skip");
    return null;
  }

  const token = localStorage.getItem("access_token") || "";
  const url = REACT_APP_API_URL; // https://v-office.ats.am

  if (socket && lastToken !== token) resetSocket();
  lastToken = token;

  if (!socket) {
    socket = io(url, {
      path: "/rest/socket.io",
      auth: { token },
      transports: ["polling"],
      withCredentials: true,

      reconnection: true,
      reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
      reconnectionDelay: 800,
      reconnectionDelayMax: 2500,
      timeout: 15000,
    });

    hasInitListeners = false;
  }

  if (!hasInitListeners) {
    hasInitListeners = true;

    socket.on("connect", () => {
      console.log("[socket] connected:", socket.id);
      console.log("[socket] transport:", socket.io.engine.transport.name);
    });

    socket.on("connect_error", (err) => {
      console.log("[socket] connect_error:", err?.message || err);
    });

    socket.io.on("reconnect_attempt", (a) => {
      console.log(`[socket] reconnect_attempt ${a}/${MAX_RECONNECT_ATTEMPTS}`);
    });

    socket.io.on("reconnect_failed", () => {
      console.log("[socket] reconnect_failed -> STOP until resetSocket()");
      disabledUntilReset = true;
      try { socket.disconnect(); } catch {}
    });
  }

  return socket;
}

export function resetSocket() {
  disabledUntilReset = false;
  if (socket) {
    try {
      socket.removeAllListeners();
      socket.io?.removeAllListeners();
      socket.disconnect();
    } catch {}
  }
  socket = null;
  hasInitListeners = false;
}
